import { Tooltip, Typography } from "antd";
import { HelpIcon } from "components/Icons";
import React from "react";

const { Link } = Typography;

interface CommonToolTipsProps {
  type: "aatiScore" | "baseScore" | "epssScore";
}

export const tooltipContent = {
  aatiScore: (
    <>
      ArmorCode Advanced Threat Intelligence{" "}
      <Link
        className="link-hover"
        onClick={(e) => e.stopPropagation()}
        href="/api/jwt/zendesk/sso?return_to=https://support.armorcode.com/hc/en-us/articles/31190039844499-Understanding-ArmorCode-s-Advanced-Threat-Intelligence-AATI"
      >
        (Learn more)
      </Link>
    </>
  ),
  baseScore: <>Based Score from NVD, CNA or 3rd party</>,
  epssScore: (
    <>
      Exploit Prediction Scoring System{" "}
      <Link
        className="link-hover"
        onClick={(e) => e.stopPropagation()}
        href="https://www.first.org/epss/"
      >
        (Learn more)
      </Link>
    </>
  ),
};

const CommonToolTipsComponent: React.FC<CommonToolTipsProps> = ({ type }) => {
  return (
    <Tooltip title={tooltipContent[type]}>
      <HelpIcon />
    </Tooltip>
  );
};

export default CommonToolTipsComponent;
